import { URLS } from "@const/urls";

export const DEFAULT_TITLE = "thisisneverthat®";
export const DEFAULT_DESCRIPTION = "thisisneverthat is a contemporary fashion brand based out of Seoul.";

export const SITE_JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "thisisneverthat",
      alternateName: ["디스이즈네버댓", "thisisneverthat®"],
      url: `${window.location.origin}/`,
    },
    {
      "@type": "Organization",
      name: "thisisneverthat",
      alternateName: ["디스이즈네버댓", "thisisneverthat®"],
      url: `${window.location.origin}/`,
      logo: `${window.location.origin}/tnt_favicon.png`,
    },
  ],
};

export const META_TAGS = {
  [URLS.HOME]: {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.ACCOUNT]: {
    title: `Account - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.ADDRESSES]: {
    title: `Addresses - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.CHECKOUT]: {
    title: `Checkout - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.NEWS]: {
    title: `News - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.LOOKBOOK]: {
    title: `Lookbook - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.VIDEO]: {
    title: `Video - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.INFORMATION_MEMBERSHIP]: {
    title: `Membership - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.NOT_FOUND]: {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.ORDER_HISTORY]: {
    title: `Order History - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.INFORMATION_CONTACT]: {
    title: `Information - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.STOCKISTS]: {
    title: `Stockists - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.STORES]: {
    title: `Stores - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
  [URLS.WISHLIST]: {
    title: `Wishlist - ${DEFAULT_TITLE}`,
    description: DEFAULT_DESCRIPTION,
  },
};
